export const mcpEndpoints = {
  connections: '/oauth/connections',
  connection: '/oauth/connections/{id}',
} as const;
